import type { CSSProperties, ReactNode } from 'react'

export type ToastVariant = 'info' | 'success' | 'warning' | 'danger'

export const TOAST_VARIANTS: ToastVariant[] = [
  'info',
  'success',
  'warning',
  'danger',
]

export const TOAST_VARIANT_LABELS: Record<ToastVariant, string> = {
  info: 'Info',
  success: 'Success',
  warning: 'Warning',
  danger: 'Danger',
}

export const TOAST_DEFAULT_MESSAGE = 'Sample text'

export type ToastProps = {
  variant?: ToastVariant
  message?: string
  children?: ReactNode
  className?: string
  style?: CSSProperties
  /** Dark-surface host. Toast has one frame — pastels stay. */
  darkMode?: boolean
  /** Static variant override for the design-system showcase only. */
  previewVariant?: ToastVariant
  role?: 'status' | 'alert'
}
